import { useCurrencyFormatter } from '@app/currency';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@stockx/ui';
import { PageType } from '@app/config';
import { usePageType } from '@app/page';
import {
  PriceLineWrapper,
  PricelineStatStyles,
  MarketArrowStyles,
} from './PriceLine.styles';

const PriceLine = ({ lowestAsk, highestBid }) => {
  const currencyFormatter = useCurrencyFormatter();
  const { t } = useTranslation();
  const isHomepage = usePageType() === PageType.Home;

  return (
    <PriceLineWrapper>
      <Box
        sx={PricelineStatStyles.variants[isHomepage ? 'home' : 'browse']}
        margin={0}
        mt={isHomepage ? 1 : 0}
      >
        {lowestAsk > 0 && (
          <Box
            as="span"
            display={{ base: 'block', sm: 'initial' }}
            backgroundColor={!isHomepage ? 'beige.100' : {}}
            mt={lowestAsk > 0 ? { base: 1, sm: 0 } : {}}
            p={!isHomepage ? { base: 1, sm: 1.5 } : {}}
          >
            <Box as="span" sx={MarketArrowStyles.variants.down} /> {t('Ask')}:{' '}
            {currencyFormatter({
              number: lowestAsk,
              onlyGreaterThanZero: true,
            })}
          </Box>
        )}{' '}
        {!isHomepage && highestBid > 0 && (
          <Box
            as="span"
            display={{ base: 'block', sm: 'initial' }}
            backgroundColor="beige.100"
            ml={lowestAsk > 0 ? { base: 0, sm: 2 } : {}}
            mt={lowestAsk > 0 ? { base: 1, sm: 0 } : {}}
            p={{ base: 1, sm: 1.5 }}
          >
            <Box as="span" sx={MarketArrowStyles.variants.up} /> {t('Bid')}:{' '}
            {currencyFormatter({
              number: highestBid,
              onlyGreaterThanZero: true,
            })}
          </Box>
        )}
      </Box>
    </PriceLineWrapper>
  );
};

export default PriceLine;
